import React from 'react';
import email_logo from '../assets/images/icons/email.png';
import address_logo from '../assets/images/icons/address.png';
import logo from '../assets/images/logo/logo.png';
import phone_logo from '../assets/images/icons/phone.png';
import i18n from '../i18';
import { t } from 'i18next';

export const Fotter = () => {
  const language = i18n.language;

  return (
    <footer className="w-full relative py-16 bg-gray-500 text-white">
      {/* Subtle blurred background overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/80 backdrop-blur-2xl z-0"></div>

      <div className="relative z-10 container mx-auto px-4 md:px-20 grid grid-cols-1 md:grid-cols-3 gap-12">

        {/* Navigation */}
        <div className="text-center md:text-center">
          <h3 className="text-xl font-semibold mb-5">Company</h3>
          <ul className="space-y-3">
            <li><a href="#home" className="hover:text-gray-400 transition-colors">Home</a></li>
            <li><a href="#products" className="hover:text-gray-400 transition-colors">Our Products</a></li>
            <li><a href="#Importing" className="hover:text-gray-400 transition-colors">Importing Products</a></li>
            <li><a href="#About" className="hover:text-gray-400 transition-colors">About Us</a></li>
            <li><a href="#Brands" className="hover:text-gray-400 transition-colors">Selected Brands</a></li>
          </ul>
        </div>

        {/* Logo & About */}
        <div className="text-center md:text-center flex flex-col items-center md:items-center space-y-4">
          <img className="w-16 h-16 object-cover rounded-full shadow-md" src={logo} alt="Logo" />
          <h2 className="text-2xl font-bold">{t('footer.heading1')}</h2>
          <p className="text-gray-300 max-w-xs text-center md:text-center">{t('footer.title')}</p>
        </div>

        {/* Contact */}
        <div className="text-center md:text-center">
          <h3 className="text-xl font-semibold mb-5">Contact Us</h3>
          <div className="space-y-4">

            {/* Phone */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <img className="w-5 h-5" src={phone_logo} alt="phone" />
              </div>
              <p className="text-gray-200 text-center font-medium text-sm">9647702012007+</p>
            </div>

            {/* Email */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <img className="w-5 h-5" src={email_logo} alt="email" />
              </div>
              <p className="text-gray-200 font-medium text-sm">Alnojoom@siraj-alnojoom.com</p>
            </div>

            {/* Address */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <img className="w-5 h-5" src={address_logo} alt="address" />
              </div>
              <p className="text-gray-200 font-medium text-sm">
                Sulaymaniyah, Iraq
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-700 mt-12 pt-6 text-center text-gray-400 relative z-10">
        <p>© 2025 {t('footer.bottom')}</p>
      </div>
    </footer>
  );
};
